module.exports = __webpack_public_path__ + "static/realtime_virtual_desktop-8aa441394b221c3e53c0d3240ee936a5.png";